<div class="customersearch-forms login-forms p-0" [formGroup]="addUserForm">
  <div class="d-flex flex-wrap align-items-start mb-3">
    <div class="col-12 col-lg-auto p-0 mt-3 mb-2">
      <h3 class="color-font font-text-600">{{ 'atgUserManagement.addUser.title' | cxTranslate }}</h3>
      <p class="text-muted">{{ 'atgUserManagement.addUser.subtitle' | cxTranslate }}</p>
    </div>

    <!-- Back Button -->
    <button class="btn back-btn p-1 font-lg-size ml-auto" (click)="cancel()" type="button" title="Back to Users">
      <i class="fas fa-level-down-alt fa-rotate-90" aria-hidden="true"></i>
    </button>
  </div>

  <div class="row mx-0">
    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.firstName' | cxTranslate }} <span class="text-danger">*</span></label>
      <input type="text" class="form-control w-100" [placeholder]="'atgUserManagement.addUser.firstName' | cxTranslate" formControlName="firstName"
        [class.is-invalid]="addUserForm.get('firstName')?.invalid && addUserForm.get('firstName')?.touched" />
      <span class="highlight"></span>
      <div *ngIf="addUserForm.get('firstName')?.invalid && addUserForm.get('firstName')?.touched" class="text-danger small mt-1">
        {{ 'atgUserManagement.addUser.firstNameRequired' | cxTranslate }}
      </div>
    </div>

    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.lastName' | cxTranslate }} <span class="text-danger">*</span></label>
      <input type="text" class="form-control w-100" [placeholder]="'atgUserManagement.addUser.lastName' | cxTranslate" formControlName="lastName"
        [class.is-invalid]="addUserForm.get('lastName')?.invalid && addUserForm.get('lastName')?.touched" />
      <span class="highlight"></span>
      <div *ngIf="addUserForm.get('lastName')?.invalid && addUserForm.get('lastName')?.touched" class="text-danger small mt-1">
        {{ 'atgUserManagement.addUser.lastNameRequired' | cxTranslate }}
      </div>
    </div>

    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.email' | cxTranslate }} <span class="text-danger">*</span></label>
      <input type="email" class="form-control w-100" [placeholder]="'atgUserManagement.addUser.email' | cxTranslate" formControlName="email"
        [class.is-invalid]="addUserForm.get('email')?.invalid && addUserForm.get('email')?.touched" />
      <span class="highlight"></span>
      <ng-container *ngIf="addUserForm.get('email')?.touched">
        <div *ngIf="addUserForm.get('email')?.hasError('required')" class="text-danger small mt-1">
          {{ 'atgUserManagement.addUser.emailRequired' | cxTranslate }}
        </div>
        <div *ngIf="addUserForm.get('email')?.hasError('email')" class="text-danger small mt-1">
          {{ 'atgUserManagement.addUser.emailInvalid' | cxTranslate }}
        </div>
      </ng-container>
    </div>

    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.businessPhone' | cxTranslate }} <span class="text-danger">*</span></label>
      <input type="text" class="form-control w-100" [placeholder]="'atgUserManagement.addUser.businessPhone' | cxTranslate" formControlName="businessPhone" knBrNumbersOnly maxlength="10"
        [class.is-invalid]="addUserForm.get('businessPhone')?.invalid && addUserForm.get('businessPhone')?.touched" />
      <span class="highlight"></span>
      <ng-container *ngIf="addUserForm.get('businessPhone')?.touched">
        <div *ngIf="addUserForm.get('businessPhone')?.hasError('required')" class="text-danger small mt-1">
          {{ 'atgUserManagement.addUser.businessPhoneRequired' | cxTranslate }}
        </div>
        <div *ngIf="addUserForm.get('businessPhone')?.hasError('pattern')" class="text-danger small mt-1">
          {{ 'atgUserManagement.addUser.businessPhonePattern' | cxTranslate }}
        </div>
        <div *ngIf="addUserForm.get('businessPhone')?.hasError('minlength') && !addUserForm.get('businessPhone')?.hasError('pattern')" class="text-danger small mt-1">
          {{ 'atgUserManagement.addUser.businessPhoneMinLength' | cxTranslate }}
        </div>
        <div *ngIf="addUserForm.get('businessPhone')?.hasError('maxlength') && !addUserForm.get('businessPhone')?.hasError('pattern')" class="text-danger small mt-1">
          {{ 'atgUserManagement.addUser.businessPhoneMaxLength' | cxTranslate }}
        </div>
      </ng-container>
    </div>
  </div>

  <div class="row mx-0">
    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.address' | cxTranslate }} <span class="text-danger">*</span></label>
      <input type="text" class="form-control w-100" [placeholder]="'atgUserManagement.addUser.address' | cxTranslate" formControlName="address"
        [class.is-invalid]="addUserForm.get('address')?.invalid && addUserForm.get('address')?.touched" />
      <span class="highlight"></span>
      <div *ngIf="addUserForm.get('address')?.invalid && addUserForm.get('address')?.touched" class="text-danger small mt-1">
        {{ 'atgUserManagement.addUser.addressRequired' | cxTranslate }}
      </div>
    </div>

    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.city' | cxTranslate }} <span class="text-danger">*</span></label>
      <input type="text" class="form-control w-100" [placeholder]="'atgUserManagement.addUser.city' | cxTranslate" formControlName="city"
        [class.is-invalid]="addUserForm.get('city')?.invalid && addUserForm.get('city')?.touched" />
      <span class="highlight"></span>
      <div *ngIf="addUserForm.get('city')?.invalid && addUserForm.get('city')?.touched" class="text-danger small mt-1">
        {{ 'atgUserManagement.addUser.cityRequired' | cxTranslate }}
      </div>
    </div>

    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.country' | cxTranslate }} <span class="text-danger">*</span></label>
      <div class="select-wrapper ng-select-wrapper">
        <ng-select formControlName="country" [items]="countries$ | async" bindLabel="name" bindValue="isocode"
          [loading]="isCountryLoading" [searchable]="true" [clearable]="false" labelForId="country"
          [disabled]="isCountryLoading" class="w-100">
        </ng-select>
        <span class="custom-placeholder" *ngIf="!addUserForm.get('country')?.value">{{ 'atgUserManagement.addUser.selectCountry' | cxTranslate }}</span>
      </div>
      <span class="highlight"></span>
      <div *ngIf="addUserForm.get('country')?.invalid && addUserForm.get('country')?.touched" class="text-danger small mt-1">
        {{ 'atgUserManagement.addUser.countryRequired' | cxTranslate }}
      </div>
    </div>

    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.state' | cxTranslate }} <span class="text-danger">*</span></label>
      <div class="select-wrapper ng-select-wrapper">
        <ng-select formControlName="state" [items]="states$ | async" bindLabel="name" bindValue="isocode"
          [loading]="isStateLoading" [searchable]="true" [clearable]="false" labelForId="state"
          [disabled]="isStateLoading || !(states$ | async)?.length" class="w-100">
        </ng-select>
        <span class="custom-placeholder" *ngIf="!addUserForm.get('state')?.value">{{ 'atgUserManagement.addUser.selectState' | cxTranslate }}</span>
      </div>
      <span class="highlight"></span>
      <div *ngIf="addUserForm.get('state')?.invalid && addUserForm.get('state')?.touched" class="text-danger small mt-1">
        {{ 'atgUserManagement.addUser.stateRequired' | cxTranslate }}
      </div>
    </div>
  </div>

  <div class="row mx-0">
    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.active' | cxTranslate }} <span class="text-danger">*</span></label>
      <div class="select-wrapper ng-select-wrapper">
        <ng-select formControlName="accountStatus" [items]="accountStatusOptions" bindLabel="label" bindValue="value"
          [placeholder]="'atgUserManagement.addUser.selectActiveStatus' | cxTranslate" [searchable]="false" [clearable]="false" class="w-100"
          [disabled]="isLoadingAccountStatuses">
        </ng-select>
      </div>
      <span class="highlight"></span>
      <div *ngIf="addUserForm.get('accountStatus')?.invalid && addUserForm.get('accountStatus')?.touched" class="text-danger small mt-1">
        {{ 'atgUserManagement.addUser.activeRequired' | cxTranslate }}
      </div>
    </div>

    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.userRole' | cxTranslate }} <span class="text-danger">*</span></label>
      <div class="select-wrapper ng-select-wrapper">
        <ng-select formControlName="userRole" [items]="userRoles" bindLabel="label" bindValue="value"
          [searchable]="false" [clearable]="false"
          [disabled]="isLoadingUserRoles" class="w-100">
        </ng-select>
        <span class="custom-placeholder" *ngIf="!addUserForm.get('userRole')?.value">{{ 'atgUserManagement.addUser.selectUserRole' | cxTranslate }}</span>
      </div>
      <span class="highlight"></span>
      <div *ngIf="addUserForm.get('userRole')?.invalid && addUserForm.get('userRole')?.touched" class="text-danger small mt-1">
        {{ 'atgUserManagement.addUser.userRoleRequired' | cxTranslate }}
      </div>
    </div>

    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.language' | cxTranslate }} <span class="text-danger">*</span></label>
      <div class="select-wrapper ng-select-wrapper">
        <ng-select formControlName="language" [items]="languages" bindLabel="label" bindValue="value"
          [placeholder]="'atgUserManagement.addUser.selectLanguage' | cxTranslate" [searchable]="false" [clearable]="false" class="w-100">
        </ng-select>
      </div>
      <span class="highlight"></span>
      <div *ngIf="addUserForm.get('language')?.invalid && addUserForm.get('language')?.touched" class="text-danger small mt-1">
        {{ 'atgUserManagement.addUser.languageRequired' | cxTranslate }}
      </div>
    </div>

    <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
      <label class="text-muted">{{ 'atgUserManagement.addUser.zipCode' | cxTranslate }} <span class="text-danger">*</span></label>
      <input type="text" class="form-control w-100" [placeholder]="'atgUserManagement.addUser.zipCode' | cxTranslate" formControlName="zipCode"
        [class.is-invalid]="addUserForm.get('zipCode')?.invalid && addUserForm.get('zipCode')?.touched" />
      <span class="highlight"></span>
      <div *ngIf="addUserForm.get('zipCode')?.invalid && addUserForm.get('zipCode')?.touched" class="text-danger small mt-1">
        {{ 'atgUserManagement.addUser.zipCodeRequired' | cxTranslate }}
      </div>
    </div>
  </div>

  <atg-add-edit-users-list [userRole]="addUserForm.get('userRole')?.value" (accountsPayload)="onAccountsPayloadChange($event)"></atg-add-edit-users-list>

  <div class="col-12 p-0 mt-3 mb-4 d-flex flex-wrap">
    <button type="button" class="btn btn-primary mr-3" (click)="saveUser()" [disabled]="isSaving || addUserForm.invalid">
      {{ isSaving ? ('atgUserManagement.addUser.saving' | cxTranslate) : ('atgUserManagement.addUser.save' | cxTranslate) }}
    </button>
    <button type="button" class="btn btn-secondary" (click)="cancel()">{{ 'atgUserManagement.addUser.cancel' | cxTranslate }}</button>
  </div>
</div>
